import { render, staticRenderFns } from "./EscalationEvents.vue?vue&type=template&id=22c74891&scoped=true&"
import script from "./EscalationEvents.vue?vue&type=script&lang=js&"
export * from "./EscalationEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c74891",
  null
  
)

export default component.exports